import React from 'react'
import AssessmentCard from './AssessmentCard'

const AssessmentGrid = ({ collection, setIsOpen, setModalData }) => {

  
    return (
        <div className="libraryGrid3 flex flex-wrap items-baseline lg:w-[60rem] justify-start sm:justify-center lg:justify-start xl:w-[60rem] 2xl:w-[90rem] 2xl:px-10">

            {
                collection.map((item, index) => (
                   <AssessmentCard item={item} index={index} key={index}/>
                ))
            }
        </div>
    )
}

export default AssessmentGrid